<h2 mat-dialog-title>Confirm delete file?</h2>
<mat-dialog-content>
    <p>{{data.type}}</p>
    <p>{{data.fileName}}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="deleteFile(false)">Cancel</button>
    <button mat-raised-button (click)="deleteFile(true)">Delete</button>
</mat-dialog-actions>